import { activationValueText } from "./roofingV2QualificationView";

const NOT_CONFIGURED = "not configured";

const WEEKDAY_NAMES = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

export function weekdayLabel(value) {
  if (value === "") {
    return '""';
  }
  if (typeof value !== "number" || !Number.isInteger(value) || value < 0 || value > 6) {
    return String(value);
  }
  return `${value} ${WEEKDAY_NAMES[value]}`;
}

function readField(source, key) {
  if (!source || typeof source !== "object" || Array.isArray(source)) {
    return NOT_CONFIGURED;
  }
  if (!Object.prototype.hasOwnProperty.call(source, key) || source[key] == null) {
    return NOT_CONFIGURED;
  }
  return source[key];
}

function readPresent(source, key) {
  if (!source || typeof source !== "object" || Array.isArray(source)) {
    return NOT_CONFIGURED;
  }
  if (!Object.prototype.hasOwnProperty.call(source, key)) {
    return NOT_CONFIGURED;
  }
  return source[key];
}

function calendarRefText(value) {
  if (value === "") {
    return '""';
  }
  return value;
}

function numberList(value) {
  if (
    !Array.isArray(value)
    || value.some((item) => typeof item !== "number" || !Number.isFinite(item))
  ) {
    return { status: NOT_CONFIGURED, items: [] };
  }
  return { status: null, items: value };
}

function quotedBlank(value) {
  return value === "" ? '""' : value;
}

function hoursBlock(value) {
  if (!value || typeof value !== "object" || Array.isArray(value)) {
    return { alwaysOn: NOT_CONFIGURED, windowsStatus: NOT_CONFIGURED, windows: [] };
  }
  if (!Array.isArray(value.windows)) {
    return {
      alwaysOn: quotedBlank(readField(value, "always_on")),
      windowsStatus: NOT_CONFIGURED,
      windows: [],
    };
  }
  return {
    alwaysOn: quotedBlank(readField(value, "always_on")),
    windowsStatus: null,
    windows: value.windows.map((item, index) => ({
      index,
      weekday: readField(item, "weekday"),
      startLocal: activationValueText(readField(item, "start_local")),
      endLocal: activationValueText(readField(item, "end_local")),
    })),
  };
}

function appointmentTypes(value) {
  if (!value || typeof value !== "object" || Array.isArray(value)) {
    return { status: NOT_CONFIGURED, types: [] };
  }
  const types = Object.keys(value).map((id) => {
    const item = value[id];
    const isFree = readField(item, "is_free");
    const photosRequired = readField(item, "photos_required");
    const durationMinutes = readField(item, "duration_minutes");
    const price = readField(item, "price");
    return {
      id: activationValueText(id),
      durationMinutes: durationMinutes === "" ? '""' : durationMinutes,
      isFree: isFree === "" ? '""' : isFree,
      price: price === "" ? '""' : price,
      currency: activationValueText(readField(item, "currency")),
      photosRequired: photosRequired === "" ? '""' : photosRequired,
    };
  });
  return { status: null, types };
}

export function roofingV2ScheduleView(settings) {
  const scheduling = settings && settings.scheduling;
  const logistics = scheduling && scheduling.logistics;
  const appointments = appointmentTypes(settings && settings.appointment_types);
  const skipWeekdays = numberList(scheduling && scheduling.skip_weekdays);
  const officeHours = hoursBlock(scheduling && scheduling.office_hours);
  const botSchedule = hoursBlock(settings && settings.bot_schedule);
  const travelBufferMinutes = readField(logistics, "travel_buffer_minutes");
  const windowSizeHours = readField(logistics, "window_size_hours");
  const createMinNoticeMinutes = readField(scheduling, "create_min_notice_minutes");
  const rescheduleMinNoticeMinutes = readField(scheduling, "reschedule_min_notice_minutes");
  return {
    timezone: activationValueText(readField(scheduling, "timezone")),
    travelBufferMinutes: travelBufferMinutes === "" ? '""' : travelBufferMinutes,
    appointmentTimeFormat: activationValueText(readField(logistics, "appointment_time_format")),
    windowSizeHours: windowSizeHours === "" ? '""' : windowSizeHours,
    createMinNoticeMinutes: createMinNoticeMinutes === "" ? '""' : createMinNoticeMinutes,
    rescheduleMinNoticeMinutes: rescheduleMinNoticeMinutes === "" ? '""' : rescheduleMinNoticeMinutes,
    resourceRef: activationValueText(readField(scheduling, "resource_ref")),
    calendarRef: calendarRefText(readPresent(scheduling, "calendar_ref")),
    skipWeekdaysStatus: skipWeekdays.status,
    skipWeekdays: skipWeekdays.items,
    officeHours,
    botSchedule,
    appointmentTypesStatus: appointments.status,
    appointmentTypes: appointments.types,
  };
}

export function scheduleTimeNotices() {
  return [
    "Bot schedule controls new automatic replies and writes.",
    "Office hours are when a person is available. They are not calendar availability.",
    "Channel window is not read from bot schedule or office hours.",
  ];
}

export function scheduleSendNotice() {
  return "This screen does not promise a message will be sent.";
}

export function scheduleReopenNotice() {
  return "Reopening hours does not send the old queue and does not restore old offers.";
}

export function scheduleEmergencyNotice() {
  return "Emergency cancel is not sent from this screen.";
}

export function scheduleExpiryNotice() {
  return "No explicit-cancel expiry is available.";
}
